{
  "version": 1,
  "asset_id": "9a8ddce8-c276-4d4f-86b4-ffc76d9748ce",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/9a8ddce8-c276-4d4f-86b4-ffc76d9748ce/svc-web-design-1200.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/9a8ddce8-c276-4d4f-86b4-ffc76d9748ce/svc-web-design-1200.avif",
  "original_filename": "svc-web-design-1200.avif",
  "size": 7695,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:27:01Z"
}
